import React, { useEffect, useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter,
    Button, Text, Alert, AlertIcon, useToast,
} from '@chakra-ui/react';
import FormNegociacao from './FormNegociacao';
import { daApi, paraApi, validarNegociacao } from './negociacao';
import { salvarNegociacaoVenda } from '../../services/api';

// Edita a negociacao de uma venda ja atribuida (#1517).
const ModalNegociacao = ({ isOpen, onClose, pedido, negociacao, canalObrigatorio, onSalvo }) => {
    const toast = useToast();
    const [dados, setDados] = useState(daApi(negociacao));
    const [erro, setErro] = useState(null);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setDados(daApi(negociacao));
            setErro(null);
        }
    }, [isOpen, negociacao]);

    const salvar = async () => {
        const problema = validarNegociacao(dados, { canalObrigatorio });
        if (problema) {
            setErro(problema);
            return;
        }
        setSalvando(true);
        setErro(null);
        try {
            const r = await salvarNegociacaoVenda(pedido.id_taga, paraApi(dados));
            toast({ title: 'Negociação salva', status: 'success', duration: 2500, isClosable: true });
            onSalvo?.(pedido.id_taga, r.negociacao);
            onClose();
        } catch (e) {
            setErro(e?.response?.data?.error || 'Não foi possível salvar a negociação.');
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} isCentered size={{ base: 'full', sm: 'lg' }} scrollBehavior="inside">
            <ModalOverlay backdropFilter="blur(2px)" />
            <ModalContent borderRadius={{ base: 0, sm: 'xl' }}>
                <ModalHeader pb={1}>Negociação da venda #{pedido?.id_taga}</ModalHeader>
                <ModalCloseButton isDisabled={salvando} />
                <ModalBody>
                    <Text fontSize="sm" color="gray.600" mb={4}>
                        Registro de como a venda foi fechada. Não altera a comissão, o cadastro do cliente nem a data do pedido.
                    </Text>
                    <FormNegociacao valor={dados} onChange={(v) => { setDados(v); setErro(null); }} canalObrigatorio={canalObrigatorio} isDisabled={salvando} />
                    {erro && (
                        <Alert status="error" borderRadius="md" mt={4} fontSize="sm">
                            <AlertIcon />
                            {erro}
                        </Alert>
                    )}
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button variant="ghost" onClick={onClose} isDisabled={salvando}>Cancelar</Button>
                    <Button colorScheme="orange" onClick={salvar} isLoading={salvando} loadingText="Salvando">Salvar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalNegociacao;
